import { Grid, VStack } from "@chakra-ui/react";
import React from "react";
import CallToLoginView from "./CallToLoginView";
import { StatBox } from "./StatBox";

interface ProfileViewInterface {
  profile: any;
  isLoggedIn: boolean;
  sessionData: any;
}

function ProfileView(props: ProfileViewInterface) {
  const { profile, isLoggedIn, sessionData } = props;

  return (
    <VStack alignItems={"stretch"} gap={2}>
      <Grid gridTemplateColumns="repeat(2, 1fr)" gridGap={2} p={0}>
        <StatBox value={sessionData.sessionWordList.length}
                 translationId={'successful-words-in-this-session'}
                 bgColor={"inherit"} border={"1.5px solid"} borderColor={"lightGray.550"} />
        <StatBox value={sessionData.sessionExerciseCount}
                 translationId={'word-lists-revised-in-this-session'}
                 bgColor={"inherit"} border={"1.5px solid"} borderColor={"lightGray.550"} />
        {isLoggedIn && (<>
          <StatBox value={profile?.annualWordList}
                   translationId={'mastered-words-this-year'}
                   bgColor={"inherit"} border={"1.5px solid"} borderColor={"lightGray.550"} />
          <StatBox value={profile?.annualExerciseCount}
                   translationId={'word-lists-revised-this-year'}
                   bgColor={"inherit"} border={"1.5px solid"} borderColor={"lightGray.550"} />
        </>)}
      </Grid>
      {!isLoggedIn && <CallToLoginView />}
    </VStack>
  );
}

export default ProfileView;
